<template>
  <component
    :is="getElement(data.Link)"
    v-if="data"
    :to="data.Link"
    class="ct-buttons__button button"
    :class="[`button--${useDash(data.Type)}`, {
      'button--small': data.Small,
    }]"
  >
    <component
      :is="loadIcon(data.IconLeft)"
      v-if="data.IconLeft"
      class="icon"
      :class="[`icon--${useDash(data.IconLeft)}`, {
        'icon--arrow': data.IconLeft.includes('arrow'),
      }]"
    />
    <span>{{ data.Text }}</span>
    <component
      :is="loadIcon(data.IconRight)"
      v-if="data.IconRight"
      class="icon"
      :class="[`icon--${useDash(data.IconRight)}`, {
        'icon--arrow': data.IconRight.includes('arrow'),
      }]"
    />
  </component>
</template>

<script setup lang="ts">
import { AppLink } from '#components'

defineProps({
  data: {
    type: Object,
    required: true,
  },
})

function getElement(to: any) {
  return to ? AppLink : 'div'
}

const { loadIcon } = useStrapiIcons()
</script>
